import {IconAgent, IconLock, IconMoney} from "../../assets/icons";
import {AppRoutes} from "../../Router";
import {useNavigate} from 'react-router-dom';
import "./MenuAgent.scss";
import {useIntl} from "react-intl";
import {useLoginContext} from "../../hooks/useLoginContext";
import ResponsiveAppBar from "../../components/shared/Menubar/ResponsiveAppBar";
import { Fab } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

export function MenuAgent() {
    const {user} = useLoginContext();
    const intl = useIntl();
    const navigate = useNavigate();
    const handleSubmit = () => {
        localStorage.removeItem('personaValidada');
        navigate(AppRoutes.CATALOG, {replace: true});
    };

    const handleSubmit1 = () => {
        navigate(AppRoutes.CHANGE, {replace: true});
    };
    
    const handleSubmit2= () => {
        navigate(AppRoutes.SOLICITUDES_DE_CREDITO, {replace: true});
    };
    const handleSubmitBack = () => {
        navigate(AppRoutes.PROFILE_OPTIONS, {replace: true});
    };


    return (
        <div>
            <ResponsiveAppBar/>
            <div className="flex-container-catalog">
                <div className="flex-item-left-catalog">
                    <Fab variant="extended" color="neutral" aria-label="add"
                         onClick={handleSubmitBack} style={{float:"left"}} className="hooverButtonRed">
                        <ArrowBack sx={{mr: 1}} className="hooverButtonRedsvg"/>
                        {intl.formatMessage({id: "button_back"})}
                    </Fab>
                </div>
                <div className="flex-item-right-catalog">
                
                </div>
                <div className="flex-item-left-catalog">
                </div>
            </div>
           
            <div className="menu-agent">
                <div className="title-welcome">
                    {`${intl.formatMessage({id: "welcome"})} ${" " + user.idUser}`}
                </div>
                <div className="subtitle-menu">
                    {intl.formatMessage({id: "how_can_we_help_you_today"})}
                </div>
                <div className="menu-agent-items">
                    <div className="menu-agent-item" onClick={handleSubmit1}>
                        <div className="menu-agent-icon">
                            <IconLock />
                        </div>
                        <div className="menu-agent-item-text">
                            {intl.formatMessage({id: "change_of_password"})}
                        </div>
                    </div>
                    <div className="menu-agent-item" onClick={handleSubmit2}>
                        <div className="menu-agent-icon">
                            <IconMoney />
                        </div>
                        <div className="menu-agent-item-text">
                            {intl.formatMessage({id: "credit_applications"})}
                        </div>
                    </div>
                    <div className="menu-agent-item" onClick={handleSubmit}>
                        <div className="menu-agent-icon">
                            <IconAgent />
                        </div>
                        <div className="menu-agent-item-text">
                            {intl.formatMessage({id: "manage_credit"})}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
